
import { useSubscription } from "./useSubscription";
import type { SubscriptionFeatures } from "@/types/subscription";
import { useAuth } from "@/components/AuthProvider";

export function useSubscriptionFeatures() {
  const { plans, currentPlan, isLoading } = useSubscription();
  const { profile } = useAuth();
  
  const currentPlanFeatures = plans?.find(plan => plan.type === currentPlan)?.features || {
    calendar: true,
    workouts: true,
    training_sessions: false,
    progress: false,
    assessments: false,
    public_profile: false,
    nutrition: false,
    ai_workouts: false
  };

  const hasFeature = (feature: keyof SubscriptionFeatures): boolean => {
    if (isLoading) return false;
    
    // Block nutrition for pro users
    if (feature === 'nutrition' && profile?.subscription_plan === 'pro') {
      return false;
    }
    
    // Only trial and premium users have access to nutrition
    if (feature === 'nutrition' || feature === 'ai_workouts') {
      return profile?.subscription_plan === 'premium' || profile?.subscription_plan === 'trial';
    }
    
    return currentPlanFeatures[feature] || false;
  };

  const isPremiumFeature = (feature: keyof SubscriptionFeatures): boolean => {
    // Only show premium badge for pro users trying to access nutrition
    if (feature === 'nutrition' && profile?.subscription_plan === 'pro') {
      return true;
    }
    return false;
  };

  return {
    hasFeature,
    isPremiumFeature,
    isLoading
  };
}
